import Compressor from "compressorjs";

export async function compressImage(file: File, quality: number = 0.6): Promise<File> {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: quality,
      success(result: File) {
        resolve(result);
      },
      error(e) {
        reject(e);
      },
    });
  });
}
